import { inject, observer } from "mobx-react";
import * as React from "react";
import { Spinner, GridColumn, Button, Grid, Notice } from "telia-front-react";
const BanklinksComponent = inject(
  "translateStore",
  "paymentStore",
  "banklinkStore"
)(
  observer(
    class BanklinksComponent2 extends React.Component {
      constructor(props) {
        super(props);
        this.state = { redirecting: false };
      }
      componentDidMount() {
        this.props.banklinkStore?.loadBanklinks(this.props.paymentProps?.banklinkPayment?.v2 ?? false);
      }
      render() {
        const { banklinks } = this.props.banklinkStore;
        if (!banklinks || banklinks.isInitialLoading || this.state.redirecting) {
          return /* @__PURE__ */ React.createElement(Spinner, null);
        } else if (banklinks.isFinishedWithError) {
          return this.banklinksFailedToLoadNotice();
        } else if (banklinks.isFinished) {
          const banklinkButtons = this.bankButtons().map((buttonProps, i) => /* @__PURE__ */ React.createElement(GridColumn, { key: i, width: ["xs"] }, /* @__PURE__ */ React.createElement(Button, { ...buttonProps, disabled: this.props.paymentStore.amountFieldHasError })));
          return /* @__PURE__ */ React.createElement(Grid, { align: ["center-xs"] }, banklinkButtons);
        }
      }
      bankButtons() {
        return this.props.banklinkStore.banklinks.payload.map((banklink) => {
          return {
            type: "outer-" + banklink.styleName,
            text: banklink.name,
            onClick: () => this.onPaymentRequest(banklink)
          };
        });
      }
      onPaymentRequest(banklink) {
        const { referenceNumber, brand, source, paymentOrderParams } = this.props.paymentProps;
        const { returnUrl, successUrl, processingUrl, failedUrl, onRedirectToBank } = this.props.paymentProps.banklinkPayment;
        if (onRedirectToBank) {
          onRedirectToBank(banklink.name);
        }
        this.setState({ redirecting: true });
        if (banklink.version === "V2") {
          this.props.banklinkStore.directToBankV2({
            bankId: banklink.id,
            amount: this.props.paymentStore.paymentAmount,
            referenceNumber,
            language: this.props.translateStore.currentLanguage,
            brand: brand ?? "TELIA",
            source,
            returnUrl,
            paymentOrderParams
          });
          return;
        }
        this.props.banklinkStore.directToBank({
          bankId: banklink.id,
          referenceNumber,
          amount: this.props.paymentStore.paymentAmount,
          language: this.props.translateStore.currentLanguage,
          successUrl,
          processingUrl,
          failedUrl,
          source,
          paymentOrderParams
        });
      }
      banklinksFailedToLoadNotice() {
        const { translate } = this.props.translateStore;
        return /* @__PURE__ */ React.createElement(Notice, { id: "banklinks-failed-to-load-notice", type: "error" }, translate("payment.banklinks.failed-to-load"));
      }
    }
  )
);
export {
  BanklinksComponent
};
